const updates = [
  { id: 1, date: '08月01日', title: '《春日华尔兹》第16集大结局上线', tag: '韩剧更新', isNew: true },
  { id: 2, date: '08月01日', title: '《暗影追踪》第三季第8集同步更新', tag: '日剧更新', isNew: true },
  { id: 3, date: '07月31日', title: '新剧《急诊室的故事》全集一次性上线', tag: '新剧上线', isNew: false },
  { id: 4, date: '07月31日', title: '《首尔恋爱指南》第12集甜蜜放送', tag: '韩剧更新', isNew: false },
  { id: 5, date: '07月30日', title: '《江户物语》特别篇加长版发布', tag: '特别企划', isNew: false },
  { id: 6, date: '07月30日', title: '平台播放器升级：新增倍速播放功能', tag: '功能更新', isNew: false },
  { id: 7, date: '07月29日', title: '《深夜食堂》第五季完整上线', tag: '日剧更新', isNew: false },
  { id: 8, date: '07月29日', title: '7月热播榜揭晓：春日华尔兹登顶', tag: '月度榜单', isNew: false },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            追剧日历
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            每日剧集更新动态速览，追剧永远快人一步
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updates.map((item, idx) => (
              <div
                key={item.id}
                className={`relative pb-8 ${idx === updates.length - 1 ? 'pb-0' : ''}`}
              >
                <span
                  className={`absolute -left-[25px] w-3 h-3 rounded-full border-2 border-background-100 ${
                    item.isNew ? 'bg-primary-500' : 'bg-background-300'
                  }`}
                ></span>

                <div className="bg-background-50 rounded-lg border border-background-200/60 p-4 ml-4">
                  <div className="flex items-center gap-2 flex-wrap mb-1.5">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span
                      className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                        item.isNew
                          ? 'bg-primary-100 text-primary-700'
                          : 'bg-secondary-100 text-secondary-700'
                      }`}
                    >
                      {item.tag}
                    </span>
                    {item.isNew && (
                      <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-accent-500 text-white whitespace-nowrap">
                        NEW
                      </span>
                    )}
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-950">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}